import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { InvoiceInitProvider } from "contexts/invoicePage/InvoiceInitContext";
import { InvoiceFormProvider } from "contexts/invoicePage/InvoiceFormContext";
import { InvoiceCreateContent } from "./InvoiceCreateContent";
var providers = [
    function(children) {
        return /*#__PURE__*/ _jsx(InvoiceInitProvider, {
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(InvoiceFormProvider, {
            children: children
        });
    }
];
var PageProvider = function(param) {
    var children = param.children;
    return providers.reduceRight(function(acc, ProviderFn) {
        return ProviderFn(acc);
    }, children);
};
export function InvoiceCreate() {
    return /*#__PURE__*/ _jsx(PageProvider, {
        children: /*#__PURE__*/ _jsx(InvoiceCreateContent, {})
    });
}
